export default function getMonthName(date: Date) {
  if (!date) return null;
  const monthNames = [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember"
  ];
  const d = new Date(date);
  return monthNames[d.getMonth()];
}
